import React, { useState } from 'react';
import NineSlice from './NineSlice';

function MissionDetail({ mission, allMissions, keyItemsTemporal, onBack, onMissionChange }) {
  const [phase, setPhase] = useState('intro'); // 'intro' | 'detail'

  const temporalMap = {};
  if (keyItemsTemporal) {
    keyItemsTemporal.forEach(item => { temporalMap[item.itemId] = item; });
  }

  const keyCount = mission.items.filter(i => i.tag === 'KEY').length;
  const avgWrongRate = mission.items.length > 0
    ? mission.items.reduce((s, i) => s + i.wrongRate, 0) / mission.items.length : 0;
  const diffLabel = mission.difficulty === 'hard' ? '어려움' : mission.difficulty === 'medium' ? '보통' : '쉬움';
  const levels = mission.levels || {};
  const lowAcc = levels['하위'] ? Math.round(levels['하위'].accuracy * 100) : null;
  const midAcc = levels['중위'] ? Math.round(levels['중위'].accuracy * 100) : null;
  const highAcc = levels['상위'] ? Math.round(levels['상위'].accuracy * 100) : null;

  // 학습 팁
  const tips = [];
  if (mission.isKey) tips.push('이 토픽은 단원 전체에 큰 영향을 미치는 핵심 토픽이에요. 반드시 이해하고 넘어가세요!');
  if (keyCount > 0) tips.push(`KEY 문항 ${keyCount}개는 틀리면 이후 문항에서도 연쇄적으로 어려워질 수 있어요.`);
  if (avgWrongRate > 0.3) tips.push(`평균 오답률이 ${Math.round(avgWrongRate * 100)}%로 높은 편이에요. 기초 개념부터 차근차근 복습하세요.`);
  if (lowAcc !== null && lowAcc < 50) tips.push(`하위 학생 정답률이 ${lowAcc}%에요. 기초가 부족하면 이전 단계부터 다시 학습해보세요.`);
  if (mission.bonusMultiplier > 1) tips.push(`이 미션은 보너스 x${mission.bonusMultiplier}! 집중하면 높은 점수를 얻을 수 있어요.`);
  if (tips.length === 0) tips.push('차분하게 문제를 풀어보세요. 모르는 문제는 표시해두고 나중에 다시 도전!');

  const prevMission = allMissions.find(m => m.order === mission.order - 1);
  const nextMission = allMissions.find(m => m.order === mission.order + 1);

  const goToMission = (m) => {
    if (onMissionChange) {
      onMissionChange(m);
    }
    setPhase('intro');
    window.scrollTo(0, 0);
  };

  const P = process.env.PUBLIC_URL;

  // ── 1단계: 양피지 요약 카드 ──
  if (phase === 'intro') {
    return (
      <div className="mission-detail">
        <button className="back-btn" onClick={onBack}>🗺️ 학습 맵으로</button>

        <div className="scroll-card">
          {/* 양피지 배경 */}
          <img src={`${P}/assets/map.png`} alt="" className="scroll-card-bg" />

          <div className="scroll-card-content">
            <div className="scroll-card-inner">
              {/* 미션 번호 & 제목 */}
              <div className="sc-header">
                <span className="sc-mission-label">
                  {mission.isKey ? '🔑' : '📜'} 미션 {mission.order}
                </span>
                <h2 className="sc-title">{mission.topic}</h2>
                <div className="sc-badges">
                  {mission.isKey && <span className="sc-badge sc-badge-key">핵심 토픽</span>}
                  <span className="sc-badge sc-badge-diff">{diffLabel}</span>
                </div>
              </div>

              {/* 아이콘 스탯 그리드 */}
              <div className="sc-stats">
                <div className="sc-stat-item">
                  <img src={`${P}/assets/ui/Icon_03.png`} alt="" className="sc-stat-icon" />
                  <span className="sc-stat-value">{mission.missionScore}점</span>
                  <span className="sc-stat-label">획득 점수</span>
                </div>
                <div className="sc-stat-item">
                  <img src={`${P}/assets/ui/Icon_06.png`} alt="" className="sc-stat-icon" />
                  <span className="sc-stat-value">{keyCount}개</span>
                  <span className="sc-stat-label">KEY 문항</span>
                </div>
                <div className="sc-stat-item">
                  <img src={`${P}/assets/ui/Icon_05.png`} alt="" className="sc-stat-icon" />
                  <span className="sc-stat-value">{mission.totalItems}문항</span>
                  <span className="sc-stat-label">총 문항</span>
                </div>
                <div className="sc-stat-item">
                  <img src={`${P}/assets/ui/Icon_11.png`} alt="" className="sc-stat-icon" />
                  <span className="sc-stat-value">{(mission.correlation * 100).toFixed(0)}%</span>
                  <span className="sc-stat-label">단원 영향력</span>
                </div>
              </div>

              {/* 시작하기 버튼 */}
              <button className="sc-start-btn" onClick={() => setPhase('detail')}>
                <img src={`${P}/assets/ui/Icon_07.png`} alt="" className="sc-start-arrow" />
                학습 가이드 보기
              </button>
            </div>
          </div>
        </div>

        {/* 이전/다음 미션 네비 */}
        <div className="sc-nav">
          {prevMission ? (
            <NineSlice preset="paperMedium" className="sc-nav-btn" style={{ width: 60, height: 50 }}
              onClick={() => goToMission(prevMission)}>
              <img src={`${P}/assets/ui/Icon_08.png`} alt="이전" className="sc-nav-icon sc-nav-icon-prev" />
            </NineSlice>
          ) : <div style={{ width: 60 }} />}
          {nextMission ? (
            <NineSlice preset="paperMedium" className="sc-nav-btn" style={{ width: 60, height: 50 }}
              onClick={() => goToMission(nextMission)}>
              <img src={`${P}/assets/ui/Icon_08.png`} alt="다음" className="sc-nav-icon" />
            </NineSlice>
          ) : <div style={{ width: 60 }} />}
        </div>
      </div>
    );
  }

  // ── 2단계: 상세 가이드 ──
  return (
    <div className="mission-detail">
      <button className="back-btn" onClick={() => setPhase('intro')}>
        <img src={`${P}/assets/ui/Icon_08.png`} alt="" style={{ width: 20, imageRendering: 'pixelated' }} />
        미션 요약으로
      </button>

      {/* 제목 배너 */}
      <NineSlice preset="paperWide" className="detail-banner" style={{ width: '100%', maxWidth: 700, margin: '0 auto 16px', height: 60 }}>
        <span className="detail-banner-text">
          {mission.isKey ? '🔑' : '📜'} 미션 {mission.order}. {mission.topic}
        </span>
      </NineSlice>

      {/* 학습 가이드 */}
      <div className="guide-section">
        <h3 className="guide-section-title">
          <img src={`${P}/assets/ui/Icon_11.png`} alt="" className="guide-icon" />
          학습 가이드
        </h3>
        <ul className="guide-tips">
          {tips.map((tip, i) => <li key={i}>{tip}</li>)}
        </ul>
      </div>

      {/* 수준별 정답률 */}
      {(lowAcc !== null || midAcc !== null || highAcc !== null) && (
        <div className="guide-section">
          <h3 className="guide-section-title">
            <img src={`${P}/assets/ui/Icon_06.png`} alt="" className="guide-icon" />
            수준별 정답률
          </h3>
          <div className="guide-levels">
            {[
              { label: '상위', pct: highAcc, cls: 'lv-high' },
              { label: '중위', pct: midAcc, cls: 'lv-mid' },
              { label: '하위', pct: lowAcc, cls: 'lv-low' },
            ].map(lv => lv.pct !== null && (
              <div key={lv.label} className="guide-level-row">
                <span className="guide-level-label">{lv.label}</span>
                <div className="guide-level-track">
                  <div className={`guide-level-fill ${lv.cls}`} style={{ width: `${lv.pct}%` }}>
                    {lv.pct}%
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* 문항 목록 */}
      <div className="guide-section">
        <h3 className="guide-section-title">
          <img src={`${P}/assets/ui/Icon_05.png`} alt="" className="guide-icon" />
          문항 목록 ({mission.items.length}개)
        </h3>
        <div className="guide-items">
          {mission.items.map((item, idx) => {
            const isKey = item.tag === 'KEY';
            const isImportant = item.tag === 'IMPORTANT';
            const temporal = temporalMap[item.itemId];

            return (
              <div key={item.itemId} className={`guide-item ${isKey ? 'guide-item-key' : ''} ${isImportant ? 'guide-item-imp' : ''}`}>
                <span className="guide-item-num">
                  {isKey ? '🔑' : isImportant ? '❗' : `${idx + 1}`}
                </span>
                <div className="guide-item-info">
                  <span className="guide-item-id">
                    문항 {item.itemId}
                    {isKey && <span className="guide-tag-key"> KEY</span>}
                    {isImportant && <span className="guide-tag-imp"> 중요</span>}
                  </span>
                  <span className="guide-item-meta">
                    {item.evalType} · {item.itemType} · 오답률 {Math.round(item.wrongRate * 100)}%
                    {temporal && ` · 후속영향 ${temporal.subsequentImpact}개`}
                  </span>
                </div>
                <div className="guide-item-score">
                  <img src={`${P}/assets/ui/Icon_03.png`} alt="" style={{ width: 18, imageRendering: 'pixelated' }} />
                  {item.score}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* 하단 네비 */}
      <div className="sc-nav" style={{ marginTop: 20 }}>
        {prevMission ? (
          <NineSlice preset="paperMedium" className="sc-nav-btn" style={{ width: 60, height: 50 }}
            onClick={() => goToMission(prevMission)}>
            <img src={`${P}/assets/ui/Icon_08.png`} alt="이전" className="sc-nav-icon sc-nav-icon-prev" />
          </NineSlice>
        ) : <div style={{ width: 60 }} />}

        <button className="back-btn" style={{ marginBottom: 0 }} onClick={onBack}>🗺️ 학습 맵으로</button>

        {nextMission ? (
          <NineSlice preset="paperMedium" className="sc-nav-btn" style={{ width: 60, height: 50 }}
            onClick={() => goToMission(nextMission)}>
            <img src={`${P}/assets/ui/Icon_08.png`} alt="다음" className="sc-nav-icon" />
          </NineSlice>
        ) : <div style={{ width: 60 }} />}
      </div>
    </div>
  );
}

export default MissionDetail;
